import script from "./PageTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PageTable.vue?vue&type=script&setup=true&lang=js"

import "./PageTable.vue?vue&type=style&index=0&id=19836d06&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/yang/wms-image/wms-image-pc/Commodity_Wms_Pc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19836d06"]])

export default __exports__